/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 17:18
 */

/**
 * Enumeration for quest condition logic
 */
export class OfferQuestConditionLogicEnum {
    public static AND: OfferQuestConditionLogicEnum = new OfferQuestConditionLogicEnum("AND");
    public static OR: OfferQuestConditionLogicEnum = new OfferQuestConditionLogicEnum("OR");
    public static XOR: OfferQuestConditionLogicEnum = new OfferQuestConditionLogicEnum("XOR");
    public static NOT: OfferQuestConditionLogicEnum = new OfferQuestConditionLogicEnum("NOT");

    private _operation: string;

    constructor(operation: string) {
        this._operation = operation;
    }

    /**
     * Gets the enumeration object from given operation string
     * @param operation
     * @return
     */
    public static getConditionLogicByName(operation: string): OfferQuestConditionLogicEnum {
        switch (operation) {
            case "AND":
                return OfferQuestConditionLogicEnum.AND;
            case "OR":
                return OfferQuestConditionLogicEnum.OR;
            case "XOR":
                return OfferQuestConditionLogicEnum.XOR;
            case "NOT":
                return OfferQuestConditionLogicEnum.NOT;
        }
        return null;
    }

    public toString(): string {
        return this._operation;
    }
}
